module.exports = __webpack_public_path__ + "img/center-details-data4.01053a07.png";